import React, { useState, useEffect } from "react";
import bytesToDisplayHelper from "../../../../../utils/bytesToDisplayHelper.js";
import GetTransformedDate from "../../../../../utils/dateViewTransformer.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";
import apiRequest from "../../../../../utils/ApiRequest/apiRequest.js";
import { useUser } from "contexts/userContext/userContext.js";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const formStatusColorsObj = {
  ordercreated: "rgb(4, 82, 129)",
  uploading: "rgb(10, 130, 197)",
  sent: "rgb(45, 174, 184)",
  downloaded: "rgb(158, 193, 38)",
  pending_removed: "rgb(251, 174, 0)",
  removed: "rgb(244, 99, 11)",
  error: "rgb(233, 18, 86)",
  uploading_error: "rgb(189, 18, 136)",
  custom1: "#F24812",
  custom2: "#E6006D",
  custom3: "#B7148C",
};

const DisplayFormMails = ({
  selectedFormArray,
  selectedFormNameArray,
  item,
  setDisplayDatepicker,
  setshowFormsList,
  index,
  showStatusesList,
  setShowStatusesList,
}) => {
  const { getTextByKey, getDirection } = useContent();
  const [statusesList, setStatusesList] = useState([]);
  const [statusMail, setStatusMail] = useState(null);
  const [mailDetails, setmailDetails] = useState(null);
  const { setModal} = useModal();
  const { isPremium} = useUser();
  const openStatusesList = () => {
    if(isPremium()){
      const isOpen =
      showStatusesList === item.SentMail_Upload_Session_BigIntID ? true : false;
    setShowStatusesList(!isOpen ? item.SentMail_Upload_Session_BigIntID : null);
    }else{
      setModal(() => <EmbedLimitOptionsModal />);

    }
  
  };
  const changeStatus = async (mailStatusName) => {
    const body = {
      MailId: item.SentMail_Upload_Session_BigIntID,
      MailEmbedDynamicUserStatus: mailStatusName,
      UserId: item.SentMail_Sender_Id,
    };
    const response = await apiRequest(
      "Mails",
      "UpdateMailEmbedDynamicUserStatus",
      body,
      "POST"
    );
    if (response.status === "success") {
      setStatusMail(mailStatusName);
      setShowStatusesList(null);
    } else {
    }
  };

  useEffect(() => {
    showDynamicStatuses();
  }, []);
  const showDynamicStatuses = async () => {
    const parameters = {
      userId: item.SentMail_Sender_Id,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedStatusListByUserIdReact",
      parameters
    );
    if (response.status === "success") {
      setStatusesList(response.data.EmbedStatusesList);
    } else {
    }
  };

  const getStatusName = (
    sentMailStatus,
    sentMailDownloadsCount,
    userStatus
  ) => {
    if (statusMail !== null) {
      return statusMail;
    } else if (userStatus !== null) {
      return userStatus;
    } else {
      switch (sentMailStatus.toUpperCase()) {
        case "CREATED":
          return getTextByKey("created-status-embed");
        case "UPLOADING":
        case "RESENDING":
          return getTextByKey("uploading-embed-status");
        case "SENT":
        case "UPLOADED":
        case "SENDING":
          if (statusMail !== null) {
            return statusMail;
          } else {
            if (userStatus !== null) {
              return userStatus;
            } else {
              if (sentMailDownloadsCount > 0) {
                return getTextByKey("downloaded-status-embed");
              } else {
                return getTextByKey("sent-status-embed");
              }
            }
          }
        case "PENDING_REMOVED":
          return getTextByKey("pending-removed-status-embed");
        case "REMOVED":
        case "CREATED_REMOVED":
          return getTextByKey("removed-status-embed");
        case "SIZE_VALIDATION":
        case "SIZE_ERROR":
        case "VIOLATION":
        case "ERROR":
          return getTextByKey("error-status-embed");
        case "UPLOADING_ERROR":
          return getTextByKey("uploading-error-status-embed");
        default:
          return sentMailStatus;
      }
    }
  };

  useEffect(() => {
    if (item) {
      setmailDetails(item);
    }
  }, [item]);

  const calculateColor = (
    sentMailStatus,
    sentMailDownloadsCount,
    userStatus
  ) => {
    if (statusMail !== null) {
      return formStatusColorsObj["custom1"];
    } else if (userStatus !== null) {
      return calculateCustomStatusColor(userStatus);
    } else {
      switch (sentMailStatus.toUpperCase()) {
        case "CREATED":
          return formStatusColorsObj["ordercreated"];
        case "UPLOADING":
        case "RESENDING":
          return formStatusColorsObj["uploading"];
        case "SENT":
        case "UPLOADED":
        case "SENDING":
          if (statusMail !== null) {
            return formStatusColorsObj[statusMail];
          } else {
            if (userStatus !== null) {
              return calculateCustomStatusColor(userStatus);
            } else {
              if (sentMailDownloadsCount > 0) {
                return formStatusColorsObj["downloaded"];
              } else {
                return formStatusColorsObj["sent"];
              }
            }
          }
        case "PENDING_REMOVED":
          return formStatusColorsObj["pending_removed"];
        case "REMOVED":
        case "CREATED_REMOVED":
          return formStatusColorsObj["removed"];
        case "SIZE_VALIDATION":
        case "SIZE_ERROR":
        case "VIOLATION":
        case "ERROR":
          return formStatusColorsObj["error"];
        case "UPLOADING_ERROR":
          return formStatusColorsObj["uploading_error"];
        default:
          return formStatusColorsObj["custom1"];
      }
    }
  };

  const calculateCustomStatusColor = (customStatus) => {
    let color = formStatusColorsObj["custom1"];
    if (statusesList.length > 0) {
      if (customStatus === statusesList[0].StatusTitle) {
        color = formStatusColorsObj["custom1"];
      } else if (customStatus === statusesList[1].StatusTitle) {
        color = formStatusColorsObj["custom2"];
      } else {
        color = formStatusColorsObj["custom3"];
      }
    }
    return color;
  };

  return (
    <div className="mail-item" key={index}>
      <div className="header">
        {showStatusesList === item.SentMail_Upload_Session_BigIntID ? (
          <div
            className={`list-statuses ${
              getDirection() === "rtl" ? "list-statuses-rtl" : ""
            }`}
          >
            {statusesList.length > 0 &&
              statusesList.map((item, i) => (
                <div
                  onClick={() => {
                    changeStatus(item.StatusTitle);
                  }}
                  className="status-item"
                  key={i}
                >
                  {item.StatusTitle}
                </div>
              ))}
          </div>
        ) : null}
        <div className="left-side">
          {getTextByKey("embed-export-shipping-number")}:{" "}
          <b>{item.SentMail_Upload_Session_BigIntID}</b>
        </div>
        <div
          className={`right-side ${
            getDirection() === "rtl" ? "status-rtl" : ""
          }`}
        >
          <div className="status">
            {getDirection() === "rtl" ? (
              <>
                {" "}
                <div
                  style={{
                    backgroundColor: calculateColor(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    ),
                  }}
                  className="change-status-icon"
                  onClick={() => {
                    openStatusesList();
                    setshowFormsList(false);
                    setDisplayDatepicker(false);
                  }}
                >
                  <div className="background-dark">
                    <i className="fas fa-sort-down"></i>
                  </div>
                </div>
                <div
                  className="status-title"
                  style={{
                    backgroundColor: calculateColor(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    ),
                  }}
                >
                  <span>
                    {getStatusName(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    )}
                  </span>
                </div>{" "}
              </>
            ) : (
              <>
                {" "}
                <div
                  className="status-title"
                  style={{
                    backgroundColor: calculateColor(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    ),
                  }}
                >
                  <span>
                    {getStatusName(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    )}
                  </span>
                </div>
                <div
                  style={{
                    backgroundColor: calculateColor(
                      item.SentMail_Status,
                      item.SentMail_DownloadsCount,
                      item.SentMail_Embed_Dynamic_User_Status
                    ),
                  }}
                  className="change-status-icon"
                  onClick={() => {
                    openStatusesList();
                    setshowFormsList(false);
                    setDisplayDatepicker(false);
                  }}
                >
                  <div className="background-dark">
                    <i className="fas fa-sort-down"></i>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="body">
        <div className="top-body line">
          <div className="text-form">
            {getTextByKey("embed-export-form-title")}:{" "}
            {selectedFormArray.map((item2, i) => {
              return item.SentMail_EmbedAccountId === item2
                ? selectedFormNameArray[i]
                : null;
            })}
          </div>
          <div className="text-form">
            {getTextByKey("embed-export-download-count")}:{" "}
            {item.SentMail_DownloadsCount}
          </div>
          <div className="text-form">
            {getTextByKey("embed-export-create-date")}:{" "}
            <GetTransformedDate
              date={item.SentMail_Creation_Date}
              fullView={true}
              showDay={false}
              showTime={true}
            />
          </div>
        </div>
        <div className="bottom-body line">
          <div className="text-form">
            {getTextByKey("embed-export-email-size")}:{" "}
            {bytesToDisplayHelper(item.SentMail_Upload_Total_Size).size}
            {bytesToDisplayHelper(item.SentMail_Upload_Total_Size).type}
          </div>
          <div className="text-form">
            {getTextByKey("embed-export-files-count")}:{" "}
            {item.SentMail_Upload_Files_Count}
          </div>
          <div className="text-form red">
            {getTextByKey("embed-export-removal-date")}:{" "}
            {item.SentMail_Removal_Date ? (
              <GetTransformedDate
                date={item.SentMail_Removal_Date}
                fullView={true}
                showDay={false}
              />
            ) : (
              getTextByKey("jumboforms-delete-files-manually")
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplayFormMails;
